import * as React from 'react';
import {IconButton, Popover, WithStyles, withStyles,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { ISchedule } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { applyChanges } from './ShiftDaysCalc';
import LeftIcon from "@material-ui/icons/ArrowBackIosRounded";
import RightIcon from "@material-ui/icons/ArrowForwardIosRounded";
import SelectedIcon from "@material-ui/icons/RadioButtonChecked";
import NotSelectedIcon from "@material-ui/icons/RadioButtonUnchecked";
import BackArrowIcon from "@material-ui/icons/ArrowBackIosRounded";
import { styleColors } from 'src/main.style';
import Checkbox from '@components/common/checkbox/checkbox.component';
import VVFullDatePicker from '@components/common/timepicker/VVFullDatePicker';

const tn: TranslateNew = TranslateNew.getInstance();



interface IState {
  shift:number;
  flip:boolean;
  startFromDate:boolean;
  startDate:Date;
  editStartDate:boolean;
}

interface IProps extends WithStyles<typeof EditActionStyle> {
  selectedDays:IDateRange[];
  scheduleEditBase:ISchedule|undefined; 
  scheduleEditPreview:ISchedule|undefined; 
  updatePreview:(schedule:ISchedule) => void;
  updateBase:(schedule:ISchedule) => void;
  close:(finished:boolean) => void;
}

class ShiftDays extends React.Component<IProps, IState> {
  private startDateRef:React.RefObject<HTMLDivElement> = React.createRef();

  constructor(props: IProps) {
    super(props);
    

    this.state = {
      shift:0,
      flip:false,
      startFromDate:false,
      startDate:new Date(),
      editStartDate:false,
    };
  }

  public componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any): void {
    if (prevProps.selectedDays !== this.props.selectedDays) {
      this.updatePreview();
    }
  }

  public render() {
    const {classes} = this.props;
    const {shift, startFromDate, startDate, editStartDate} = this.state;

    return (<>
      <div className={classes.paneOptions} >
        <Button className={classes.paneOption} style={{textAlign: 'start'}}  startIcon={<BackArrowIcon />} classes={{text:classes.backButton}}
          onClick={() => {
          if (this.props.scheduleEditBase) {
            this.props.updatePreview(this.props.scheduleEditBase);  
          }
          this.props.close(false);
        }}>
          {tn.lang.back}
        </Button>
        <div className={classes.paneOption+" "+classes.paneCenter} > 
          <div style={{fontSize:'10px'}}>{""}</div>
        </div>
        <Button className={classes.paneOption} variant="contained" color="primary" style={{textAlign: 'end', marginRight:'10px'}} 
          disabled={((shift === 0 ) && (!this.state.flip))} onClick={() => this.execute()} classes={{contained:classes.buttonContained}} >
          {tn.lang.save}
        </Button>

      </div>
      <div className={classes.pane} style={{ flexDirection: 'column', alignItems: 'center', alignSelf: 'center', gap: '18px' }}>
        <div style={{ display:'flex', flexDirection: 'row', alignItems: 'center'}}>
          <IconButton onClick={() => this.shift("back")} ><LeftIcon /></IconButton>
          <div style={{fontSize: '40px', fontWeight: 600, color: styleColors.greyMedium3}}>{shift}</div>
          <IconButton onClick={() => this.shift("forward")} ><RightIcon /></IconButton>
        </div>
        <div>
          <Button startIcon={(this.state.flip?<SelectedIcon/>:<NotSelectedIcon/>)}
            variant="contained" classes={{contained:classes.gradientButton}} onClick={() => this.flip()}>
            {tn.lang.calInvert}
          </Button>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px'}}>
          <Checkbox
            id="shiftStartFromDate"
            label={tn.lang.calMakeChangesFromDate}
            checked={startFromDate}
            onChange={(event:React.ChangeEvent<HTMLInputElement>) => this.setStartFromDate(event.currentTarget.checked)}
            labelStyle={{alignItems: 'center'}}
          />
          <div ref={this.startDateRef}
            onClick={() => startFromDate && this.setState({editStartDate:true})}
            style={{
              fontSize: '18px',
              fontWeight: 600,
              padding: '8px 12px',
              minWidth: '150px',
              textAlign: 'center',
              backgroundColor: styleColors.greyLight2,
              border: `1px solid ${startFromDate?styleColors.greyMedium1:styleColors.greyLight2}`,
              borderRadius: '4px',
              opacity: startFromDate?1:0.45,
              cursor: startFromDate?'pointer':'default',
            }}>
            {tn.formatDateDayMonthYear(startDate)}
          </div>
          <Popover
            anchorEl={this.startDateRef.current}
            onClose={() => {this.setState({editStartDate:false})}}
            open={editStartDate}
            disableScrollLock={true}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
          >
            <VVFullDatePicker
              open={editStartDate}
              date={startDate}
              setDate={(date:Date) => this.setStartDate(date)}
            />
          </Popover>
        </div>
      </div>
      </>
    );
  }

  private shift(direction:"forward"|"back") {
    const shift = this.state.shift+(direction==="back"?-1:1);
    this.setState({shift})
    this.updatePreview(shift, this.state.flip, this.state.startFromDate, this.state.startDate);
  }

  private flip() {
    this.setState({flip:!this.state.flip})
    this.updatePreview(this.state.shift, !this.state.flip, this.state.startFromDate, this.state.startDate);
  }

  private setStartFromDate(startFromDate:boolean) {
    this.setState({startFromDate});
    this.updatePreview(this.state.shift, this.state.flip, startFromDate, this.state.startDate);
  }

  private setStartDate(startDate:Date) {
    this.setState({startDate});
    this.updatePreview(this.state.shift, this.state.flip, this.state.startFromDate, startDate);
  }

  private updatePreview(shift:number = this.state.shift, flip:boolean = this.state.flip,
    startFromDate:boolean = this.state.startFromDate, startDate:Date = this.state.startDate) {
    if (this.props.scheduleEditBase) {
      this.props.updatePreview(applyChanges(this.props.scheduleEditBase, shift, flip, startFromDate?startDate:undefined));
    }
  }

  private execute() {
    if (this.props.scheduleEditBase) {
      this.props.updateBase(applyChanges(this.props.scheduleEditBase, this.state.shift, this.state.flip,
        this.state.startFromDate?this.state.startDate:undefined));
      this.props.close(true);
    }
  }

}

export default withStyles(EditActionStyle)(ShiftDays);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/ShiftDays/ShiftDays.tsx